import { createSelector } from 'reselect';
import includes from 'lodash/includes';
import some from 'lodash/some';
import get from 'lodash/get';
import * as constants from './constants';
import * as actionTypes from './actionTypes';
import { groupNotificationsByTimestamp } from './helpers';
/**
 * Input selectors
 */ const mainSelector = (state)=>state[constants.MODULE_ID];
const fetchingSelector = (state)=>state[constants.MODULE_ID].fetching;
const sendingSelector = (state)=>state[constants.MODULE_ID].sending;
const errorsSelector = (state)=>state[constants.MODULE_ID].errors;
//----------------------------------------------------------------------------------------------------------------------
export const notifications = createSelector(mainSelector, (state)=>state.notifications);
/**
 * List of notifications
 */ export const notificationsRecords = createSelector(notifications, (notificationsState)=>get(notificationsState, 'records'));
export const notificationsTotal = createSelector(notifications, (notificationsState)=>get(notificationsState, 'totalRecords'));
export const notificationsTotalActive = createSelector(notifications, (notificationsState)=>get(notificationsState, 'totalActiveRecords'));
export const notificationsRecordsGrouped = createSelector([
    notificationsRecords
], (notificationsRecordsState)=>groupNotificationsByTimestamp(notificationsRecordsState));
//----------------------------------------------------------------------------------------------------------------------
export const notificationsFilter = createSelector(mainSelector, (state)=>state.notificationsFilter);
//----------------------------------------------------------------------------------------------------------------------
export const lastReceivedNotification = createSelector(mainSelector, (state)=>state.lastReceivedNotification);
//----------------------------------------------------------------------------------------------------------------------
export const hasMoreNotificationsToLoad = createSelector([
    notificationsTotal,
    notificationsFilter
], (notificationsTotalState, notificationsFilterState)=>notificationsTotalState > notificationsFilterState.limit);
export const hasAnyNotificationsToDismiss = createSelector([
    notificationsRecords
], (notificationsRecordsState)=>some(notificationsRecordsState, (notification)=>notification.status !== 'Dismissed'));
/**
 * List of notifications ids user is reading now. Only after reading it will be committed to notifications statuses.
 */ export const readNotificationsIds = createSelector(mainSelector, (state)=>state.readNotificationsIds);
export const notificationsHistoryRecords = createSelector(mainSelector, (state)=>get(state.notificationsHistory, 'records'));
//----------------------------------------------------------------------------------------------------------------------
export const isFetchNotificationsInProgress = createSelector(fetchingSelector, (state)=>includes(state, actionTypes.FETCH_LIST));
export const hasFetchNotificationsErrors = createSelector(errorsSelector, (state)=>includes(state, actionTypes.FETCH_LIST));
//----------------------------------------------------------------------------------------------------------------------
export const isDismissFilteredNotificationsInProgress = createSelector(sendingSelector, (state)=>includes(state, actionTypes.DISMISS_FILTERED_NOTIFICATIONS));
export const hasDismissFilteredNotificationsErrors = createSelector(errorsSelector, (state)=>includes(state, actionTypes.DISMISS_FILTERED_NOTIFICATIONS)); //----------------------------------------------------------------------------------------------------------------------
